import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

import type { GoogleFreeBookingLinksSettingsI18n } from "@/lib/gql/__generated__/graphql";

import { googleFreeBookingLinksSettingsI18nInputZodSchema } from "./validation-schema";

import type { GoogleFreeBookingLinksSettingsI18nZodSchemaType } from "./validation-schema";
import type { UseFormReturn } from "react-hook-form";

type Props = {
	googleFreeBookingLinksSettingsI18n: GoogleFreeBookingLinksSettingsI18n;
};

export const useGoogleFreeBookingLinksSettingsI18nForm = ({
	googleFreeBookingLinksSettingsI18n,
}: Props): UseFormReturn<GoogleFreeBookingLinksSettingsI18nZodSchemaType> => {
	const form: UseFormReturn<GoogleFreeBookingLinksSettingsI18nZodSchemaType> =
		useForm<GoogleFreeBookingLinksSettingsI18nZodSchemaType>({
			mode: "onChange",
			resolver: zodResolver(googleFreeBookingLinksSettingsI18nInputZodSchema),
			defaultValues: googleFreeBookingLinksSettingsI18n,
		});

	// form 全体がメモ化される予定らしいので、`trigger` だけが `useEffect` の依存関係に含まれるようにしている
	// @docs https://react-hook-form.com/docs/useform#:~:text=useForm%20return%20and%20useEffect%20dependencies
	const { trigger } = form;
	useEffect(() => {
		trigger();
	}, [trigger]);

	return form;
};

export { googleFreeBookingLinksSettingsI18nInputZodSchema } from "./validation-schema";
export type {
	GoogleFreeBookingLinksSettingsI18nZodParseErrorType,
	GoogleFreeBookingLinksSettingsI18nZodSchemaType,
} from "./validation-schema";
